import React from 'react';
import { ChevronDown, Folder } from 'lucide-react';
import { useProject } from '../context/ProjectContext';

const ProjectSelector: React.FC = () => {
    const { projects, currentProject, setCurrentProject, isLoading } = useProject();
    const [isOpen, setIsOpen] = React.useState(false);
    const dropdownRef = React.useRef<HTMLDivElement>(null);

    // Close when clicking outside
    React.useEffect(() => {
        const handleClickOutside = (event: MouseEvent) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
                setIsOpen(false);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);

    if (isLoading && projects.length === 0) {
        return <div className="animate-pulse h-8 w-32 bg-slate-800 rounded"></div>;
    }

    if (projects.length === 0) {
        return (
            <div className="text-xs text-slate-500 flex items-center gap-2 px-3 py-1.5 border border-slate-700 rounded-lg">
                <Folder className="w-3 h-3" />
                No Projects
            </div>
        );
    }

    return (
        <div className="relative" ref={dropdownRef}>
            <button
                onClick={() => setIsOpen(!isOpen)}
                className="flex items-center gap-2 px-3 py-1.5 bg-slate-800 hover:bg-slate-700 border border-slate-700 rounded-lg transition-colors min-w-[160px] justify-between"
            >
                <div className="flex items-center gap-2 overflow-hidden">
                    <Folder className="w-3.5 h-3.5 text-primary flex-shrink-0" />
                    <span className="text-xs font-medium text-white truncate max-w-[120px]">
                        {currentProject?.label || 'Select Project'}
                    </span>
                </div>
                <ChevronDown className={`w-3.5 h-3.5 text-slate-400 transition-transform ${isOpen ? 'rotate-180' : ''}`} />
            </button>

            {/* Dropdown Menu */}
            {isOpen && (
                <div className="absolute top-full left-0 mt-1 w-full bg-slate-800 border border-slate-700 rounded-lg shadow-xl overflow-hidden z-50 animate-in fade-in slide-in-from-top-1 duration-150">
                    <div className="max-h-60 overflow-y-auto py-1">
                        {projects.map((project) => (
                            <button
                                key={project.value}
                                onClick={() => {
                                    console.log("Selecting project:", project);
                                    setCurrentProject(project);
                                    setIsOpen(false);
                                }}
                                className={`w-full text-left px-3 py-2 text-xs transition-colors hover:bg-slate-700 flex items-center gap-2 ${currentProject?.value === project.value
                                    ? 'text-primary bg-primary/10'
                                    : 'text-slate-300'
                                    }`}
                            >
                                <Folder className="w-3 h-3 opacity-50" />
                                <span className="truncate">{project.label}</span>
                            </button>
                        ))}
                    </div>
                </div>
            )}
        </div>
    );
};

export default ProjectSelector;
